/*
* 店舗一覧・詳細用
*/
$(function () {

  /*
  * 一覧並び変更
  */
  $(document).on('change', '[name=list_order]', function () {
    let listOrder = $(this).val();
    location.href = '/shops?order=' + listOrder;
  });

  /*
  * さらに絞り込む モーダルウィンドウ オープン
  */
  $(".modal-shop-search").click(function () {
    $(".search-detail").fadeIn();
    $(".search-detail").css("display", "flex");
    $('body').css('overflow-y', 'hidden');
    $('.shop-search-check').change();
  });
  $(".modal .close").click(function () {
    $(".search-detail").css("display", "none");
    $('body').css('overflow-y', 'auto');
  });

  /*
  * 店舗詳細検索モーダル 条件クリック時
  */
  $(document).on('change', '.shop-search-check', function () {

    // チェックされているもののみ取得
    let conditions = $('.searchform .shop-search-check:checked').map(function () {
      return $(this).attr('word')
    }).get().join(',');

    // 現在の条件に表示
    $('#extracted_words').html(conditions);

  });

  /*
  * 店舗詳細検索モーダル 一括クリア
  */
  $(document).on('click', '#search-clear', function () {

    // チェックボックス クリア
    $('.searchform .shop-search-check:checked').prop('checked', false);

    // 現在の検索語句クリア
    $("#extracted_words").html('');

  });

  /*
  * 店舗詳細検索モーダル 検索実行
  */
  $(document).on('submit', '.searchform', function (event) {

    event.preventDefault();

    // 選択されているフェス取得
    let festival = $('.searchform .shop-search-check-festival:checked').map(function () {
      return $(this).val()
    }).get().join(',');

    // 選択されている料理ジャンル取得
    let genre = $('.searchform .shop-search-check-genre:checked').map(function () {
      return $(this).val()
    }).get().join(',');

    // 選択されているこだわり
    let commitment = $('.searchform .shop-search-check-commitment:checked').map(function () {
      return $(this).val()
    }).get().join(',');

    // 一覧へリダイレクト
    let url = $('[name=url]').val();
    location.href = url + '?festival=' + festival + '&genre=' + genre + '&commit=' + commitment;

  });


});
